import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../../components/MainBody/MainBody";
import MainTabList from "../../../components/MainBody/MainTabList";
import Sections from "./Sections/Sections";
import Questions from "./Questions/Questions";
import Conditions from "./Conditions/Conditions";
import Versions from "./Versions/Versions";

const tabsKey = [
  {
    name: "Versions",
    tabName: "versions",
    value: 1,
  },
  {
    name: "Sections",
    tabName: "sections",
    value: 2,
  },
  {
    name: "Questions",
    tabName: "questions",
    value: 3,
  },
  {
    name: "Conditions",
    tabName: "conditions",
    value: 4,
  },
];

const RiskAssessmentTabs = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("childTab") || "sections";
  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab,
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);
  const navigate = useNavigate();

  useEffect(() => {
    navigate(
      `/admin/aml-ctf?tab=risk-assessment&childTab=${
        tabsKey?.find((item) => item?.value === activeTab)?.tabName
      }`,
      {
        replace: true,
      },
    );
  }, [activeTab, navigate]);

  useEffect(() => {
    setActiveTab(tabsKey?.find((item) => item?.tabName === selectedTab)?.value);
  }, [selectedTab]);

  return (
    <>
      <MainBody
       search={false}
        loading={false}
        innerBody={true}
        actionAlign={"end"}
        actionContent={""}
      >
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={`bg-background relative max-h-[80vh] overflow-y-auto p-0 border-0`}
        >
          {activeTab === 1 ? (
            <Versions />
          ) : activeTab === 2 ? (
            <Sections />
          ) : activeTab === 3 ? (
            <Questions />
          ) : activeTab === 4 ? (
            <Conditions />
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default RiskAssessmentTabs;
